import React, { useState } from "react";
import MainContainer from "../../components/app/maincontainer";
import Account from "../../assets/icons/user-Round.svg";
import Language from "../../assets/icons/world.svg";
import Password from "../../assets/icons/unlock.svg";
import Privacy from "../../assets/icons/help.svg";
import Man from "../../assets/icons/avatar-man.svg";
import Inputs from "../../components/inputs/main";
import { MainBtn } from "../../components/app/buttons";
import PasswordImg from "../../assets/images/password.png";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { apiCall } from "../../data/useFetcher";
import useErrorStore from "../../data/stores/errorStore";
import useAuthStore from "../../data/stores/authStore";

const Settomgs = () => {
	const [tab, setTab] = useState("account"),
		tabs = [
			{ name: "account", icon: Account },
			{ name: "Languages", icon: Language },
			{ name: "password", icon: Password },
			{ name: "privacy policy", icon: Privacy },
		];
	return (
		<div>
			<MainContainer>
				<div className="mt-6">
					<h1 className="text-2xl font-bold text-da-gray-600">Settings</h1>
					<div className="mt-8 flex gap-10">
						<div className="w-[30%] bg-white p-5 max-h-60 rounded-lg">
							{tabs?.map(t => (
								<button
									onClick={() => setTab(t?.name)}
									style={{
										borderBottom: tab !== t?.name && "1px solid #E2E8F0",
									}}
									className={`h-12 w-full capitalize text-sm font-semibold  rounded-lg px-3 flex gap-3 items-center ${
										tab === t?.name
											? "bg-da-blue-100 text-white"
											: "bg-[#F8FAFC] text-da-blue-300"
									}`}>
									<div
										style={{
											backgroundColor: tab === t?.name ? "white" : "#007AFF26",
										}}
										className="size-10 rounded-full flex justify-center items-center">
										<img src={t?.icon} alt="" className="" />
									</div>
									<span>{t?.name}</span>
								</button>
							))}
						</div>
						<div className="w-[70%]">
							{tab === "account" && <AccountSection />}
							{tab === "password" && <PasswordSection />}
							{tab === "privacy policy" && <PrivacySection />}
						</div>
					</div>
				</div>
			</MainContainer>
		</div>
	);
};

const AccountSection = () => {
	const { user, setUser, profiles } = useAuthStore(),
		[state, setState] = useState<any>({}),
		textChange = (e?: React.ChangeEvent<HTMLInputElement>) => {
			let { name, value } = e?.target;
			setState(prev => {
				return { ...prev, [name]: value };
			});
		},
		[loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore();
	let onSubmit = async e => {
		e?.preventDefault();
		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "put",
			url: `/api/v1/user`,
			data: state,
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			setUser(response);
			return;
		}
		setLoading(false);
	};

	return (
		<div
			style={{
				boxShadow: "4px 4px 100px 0px #00000014",
			}}
			className="bg-white w-full rounded-lg px-8 py-4">
			<div
				style={{
					borderBottom: "1px solid #E2E8F0",
				}}
				className="w-full pb-3">
				<h2 className="text-base font-medium text-da-blue-400">
					General Setting
				</h2>
			</div>
			<div className="flex gap-5 my-5 items-center">
				<img src={Man} alt="" className="" />
				<div>
					<p className="text-sm inter text-slate-500 font-normal">
						We only support .JPG, .JPEG, or .PNG file.
					</p>
					<div className="flex gap-4 mt-3 items-center">
						<button className="h-10 w-36 rounded-lg bg-da-blue-100 underline text-[#F8FAFC] inter text-sm font-medium">
							Upload Photo
						</button>
						<small className="text-sm inter cursor-pointer text-da-blue-100 font-medium">
							Delete Photo
						</small>
					</div>
				</div>
			</div>
			<div className="mt-6 grid grid-cols-2 gap-6">
				<Inputs
					icon="line-md:account"
					label="First name"
					onChange={textChange}
					value={state?.firstName || user?.firstName}
					name="firstName"
				/>
				<Inputs
					icon="line-md:account"
					label="Last name"
					onChange={textChange}
					value={state?.lastName || user?.lastName}
					name="lastName"
				/>
				<Inputs
					icon="mage:email"
					label="Email"
					onChange={textChange}
					value={state?.email || user?.email}
					name="email"
					readOnly
					type="email"
				/>
				<Inputs
					icon="hugeicons:telephone"
					label="Telephone"
					onChange={textChange}
					value={state?.telephone || user?.telephone}
					name="telephone"
				/>
			</div>
			<div
				style={{
					borderBottom: "1px solid #E2E8F0",
				}}
				className="w-full pb-3 my-4">
				<h2 className="text-base font-medium text-da-blue-400">
					Personal Address
				</h2>
			</div>
			<div className="mt-4 grid grid-cols-2 gap-6">
				<Inputs
					icon="circle-flags:uk"
					label="Country"
					onChange={textChange}
					value={state?.country || profiles?.[0]?.country}
					name="country"
				/>
				<Inputs
					icon="lets-icons:world-2"
					label="City"
					onChange={textChange}
					value={state?.city || profiles?.[0]?.city}
					name="city"
				/>
				<Inputs
					icon="carbon:location"
					label="Address"
					onChange={textChange}
					value={state?.address || profiles?.[0]?.address}
					name="address"
				/>
				<Inputs
					icon="bi:mailbox"
					label="Postal Code"
					onChange={textChange}
					value={state?.postalCode || profiles?.[0]?.postalCode}
					name="postalCode"
				/>
			</div>
			<div className="mt-10 mb-2 gap-6 flex items-center">
				<MainBtn
					bg={"#3787FF"}
					color={"white"}
					text={"Save Profile"}
					onClick={e => onSubmit(e)}
					loading={loading}
				/>
				<strong className="font-medium text-sm inter text-[#EF4444]">
					No! Cancel
				</strong>
			</div>
		</div>
	);
};

const PasswordSection = () => {
	const {
		control,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm({
		defaultValues: {
			oldPassword: "",
			newPassword: "",
		},
	});

	const [loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore();
	let onSubmit = async (data: { oldPassword: string; newPassword: string }) => {
		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "put",
			url: `/api/v1/user/update-password`,
			data,
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			reset();
			return;
		}
		setLoading(false);
	};

	return (
		<div
			style={{
				boxShadow: "4px 4px 100px 0px #00000014",
			}}
			className="bg-white w-full rounded-lg px-8 py-4">
			<div
				style={{
					borderBottom: "1px solid #E2E8F0",
				}}
				className="w-full pb-3">
				<h2 className="text-base font-medium text-da-blue-400">Password</h2>
				<p className="text-sm mt-3 font-normal inter text-da-gray-500">
					Give me correct password and change password
				</p>
			</div>
			<div className="mt-6">
				<div className="flex gap-20">
					<form className="w-[60%]" onSubmit={handleSubmit(onSubmit)}>
						<div className="space-y-5">
							<div>
								<Controller
									name="oldPassword"
									control={control}
									rules={{
										required: "This field is required",
										pattern: {
											value:
												/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/g,
											message:
												"Your password must have at least one uppercase letter, one lowercase letter, one digit, one special character, and a minimum length of 8 characters.",
										},
									}}
									render={({ field: { value, onChange, name } }) => (
										<Inputs
											type="password"
											value={value}
											onChange={onChange}
											name={name}
											icon="mdi:password-outline"
											label="Old Password"
											placeholder="**********"
										/>
									)}
								/>
								{errors.oldPassword && (
									<p className="text-[#dc2626] text-xs">
										{errors.oldPassword.message}
									</p>
								)}
							</div>
							<div>
								<Controller
									name="newPassword"
									control={control}
									rules={{
										required: "This field is required",
										pattern: {
											value:
												/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/g,
											message:
												"Your password must have at least one uppercase letter, one lowercase letter, one digit, one special character, and a minimum length of 8 characters.",
										},
									}}
									render={({ field: { value, onChange, name } }) => (
										<Inputs
											type="password"
											value={value}
											onChange={onChange}
											name={name}
											icon="mdi:password-outline"
											label="New Password"
											placeholder="**********"
										/>
									)}
								/>
								{errors.newPassword && (
									<p className="text-[#dc2626] text-xs">
										{errors.newPassword.message}
									</p>
								)}
							</div>
						</div>
						<div className="mt-10 mb-2 gap-6 flex items-center">
							<MainBtn
								loading={loading}
								text={"Yes! Update"}
								bg={"#3787FF"}
								color={"white"}
							/>
							<strong
								onClick={() => reset()}
								className="font-medium text-sm inter text-[#EF4444]">
								No! Cancel
							</strong>
						</div>
					</form>
					<img src={PasswordImg} alt="" className="h-56" />
				</div>
			</div>
		</div>
	);
};

const PrivacySection = () => {
  const termsAndConditions = [
    {
      title: "Privacy Policy",
      content:
        "Our Privacy Policy outlines how we collect, use, and protect your personal information. By using  this website, you consent to the terms of our Privacy Policy.",
    },
    {
      title: "Product Information",
      content:
        "We strive to provide accurate product information, but we do not guarantee the completeness or accuracy of the information on our website. Prices and availability are subject to change without notice.",
    },
    {
      title: "Orders and Payments",
      content:
        "Placing an order on Taildo constitutes an offer to purchase the products. We reserve the right to refuse or cancel orders at our discretion. Payment information is handled securely.",
    },
    {
      title: "User Conduct",
      content:
        "By using our website, you agree not to engage in any activities that may disrupt or interfere with the proper functioning of the site. This includes but is not limited to  unauthorized access.",
    },
    {
      title: "Intellectual Property",
      content:
        "All content on Taildo, including text, images, logos, and trademarks, is the intellectual property of Taildo. Unauthorized use or reproduction is strictly prohibited.",
    },
    {
      title: "Governing Law",
      content:
        "These terms and conditions are governed by and construed in accordance with the laws.",
    },
  ];
  return (
    <div
      style={{
        boxShadow: "4px 4px 100px 0px #00000014",
      }}
      className="bg-white w-full rounded-lg px-8 py-4"
    >
      <div
        style={{
          borderBottom: "1px solid #E2E8F0",
        }}
        className="w-full pb-3"
      >
        <h2 className="text-base font-medium text-da-blue-400">
          Privacy & Policy
        </h2>
        <p className="text-sm mt-3 font-normal inter text-da-gray-500">
          These social profiles will appear on your website
        </p>
      </div>
      <div className="mt-4">
        <p className="text-sm font-normal text-da-gray-500 inter">
          By accessing and using Taildo, you agree to be bound by these terms
          and conditions. If you do not agree to all the terms and conditions,
          please refrain from using the website.{" "}
        </p>
        <div className="mt-5 space-y-4">
          {termsAndConditions?.map((term, i) => (
            <div className="">
              <h5 className="text-da-blue-400 text-sm font-semibold inter">
                {i + 1}. {term?.title}
              </h5>
              <p className="mt-1 text-sm font-normal text-da-gray-500 inter">
                {term.content}
              </p>
            </div>
          ))}
        </div>
        <div className="mt-10 mb-2 gap-6 flex items-center">
          <MainBtn
            bg={"#3787FF"}
            color={"white"}
            text={"Accepted"}
            onClick={() => console.log("object")}
          />
          <strong className="font-medium text-sm inter text-[#EF4444]">
            No! Cancel
          </strong>
        </div>
      </div>
    </div>
  );
};

export default Settomgs;
